import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import {
  CustomTablePagination,
  EnhancedSearchTableToolbar
} from "../../Utils/Tables/CustomTable";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import * as snackbarActions from "../../../actions/snackbarActions";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import { Container } from "../../Utils/styledComponents";
import { config } from "../../../Helpers/env";
import { logoutErrorMessage } from "../../../Helpers/ErrorMessages";
import { LoadingGif } from "../../Utils/Loader";
import {
  CustomTableCell,
  MuiPaper,
  StickyHeadTable
} from "../../Utils/Tables/StickyHeaderTable";
import PageTitle from "../../Utils/smsTitle";
import { SubHeader } from "../../../Containers/SubHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useDebounce } from "../../Lab/useDebounce";
import { BackButton } from "../../Utils/Buttons/DataExportationButton";
import { useExcelReports, usePdfDownload } from "../../Utils/ReusableComponents/useExcelExport";
import { dateConvert } from "../../Utils/ConvertDate";

const headData = [
  { id: "count", label: "Sl" },
  { id: "product_name", label: "Product Name" },
  { id: "generic_name", label: "Generic Name" },
  { id: "country_of_origin", label: "Origin" },
  { id: "jan", label: "Jan" },
  { id: "feb", label: "Feb" },
  { id: "mar", label: "Mar" },
  { id: "apr", label: "Apr" },
  { id: "may", label: "May" },
  { id: "jun", label: "Jun" },
  { id: "jul", label: "Jul" },
  { id: "aug", label: "Aug" },
  { id: "sep", label: "Sep" },
  { id: "oct", label: "Oct" },
  { id: "nov", label: "Nov" },
  { id: "dec", label: "Dec" }
];

const formatNumber = (num) =>
  num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "0";

const ConsumptionReport = ({ actions, snackbars }) => {
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [data, setData] = useState({ reportList: [], loading: "idle", total: 0 });
  const [activePage, setActivePage] = useState(1);
  const [debouncedValue] = useDebounce(searchValue, 600);

  const [date, setDate] = useState({
    start_date: new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10),
    end_date: dateConvert()
  });

  const { loading, total, reportList } = data;
  const { start_date, end_date } = date;

  useEffect(() => {
    setData((prev) => ({ ...prev, loading: "pending" }));

    axios
      .get(`${config.smsUrl}/creport/consumption_report`, {
        params: {
          search: debouncedValue || undefined,
          page: activePage,
          per_page: rowsPerPage,
          start_date,
          end_date
        }
      })
      .then((res) => {
        const { consumption_report = [], total_count = 0 } = res.data;
        setData({
          loading: "success",
          reportList: consumption_report,
          total: total_count
        });
      })
      .catch((err) => {
        logoutErrorMessage(err, null, actions);
        setData((prev) => ({ ...prev, loading: "error" }));
      });
  }, [debouncedValue, activePage, rowsPerPage, start_date, end_date]);

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setActivePage(1);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setActivePage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setActivePage(1);
  };

  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    setDate({ ...date, [name]: value });
    setActivePage(1);
    setPage(0);
  };

  const closeSnackbar = () => actions.snackbarActions.hideSnackbar();
  const { openBar, type, message } = snackbars;

  const excelObj = {
    file_name: "Monthly Consumption Report",
    url: "creport/consumption_report/export_excel",
    params: { start_date, end_date }
  };
  const { exportExcel, isLoading: isLoadingExcel } = useExcelReports(actions, excelObj);
  const { exportPdf, isLoading: isLoadingPdf } = usePdfDownload(actions, {
    file_name: "Monthly Consumption Report",
    url: "creport/consumption_report/export_pdf",
    params: { start_date, end_date }
  });

  const monthlyTotals = reportList.reduce((acc, row) => {
    headData.slice(4).forEach((col) => {
      acc[col.id] = (acc[col.id] || 0) + (row[col.id] || 0);
    });
    return acc;
  }, {});

  const isLoading = loading === "pending";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  return (
    <div>
      <PageTitle title="Monthly Consumption Report" />
      <SubHeader title="Reports" subTitle="Yearly Drug Consumption by Month">
        <FontAwesomeIcon icon={faChartBar} />
      </SubHeader>

      <Container>
        <MainSnackbar
          variant={type}
          open={openBar}
          message={message}
          handleCloseBar={closeSnackbar}
        />

        {/* ===== TOP SECTION ===== */}
        <div style={{ padding: "8px 0 0 0" }}>
          {/* Back + Export */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "12px",
              gap: "8px"
            }}
          >
            <BackButton to="/reports/generalreports" text="Reports" />

            <div style={{ display: "flex", gap: "8px" }}>
              <button
                type="button"
                onClick={exportExcel}
                disabled={isLoadingExcel}
                className="btn btn-sm text-white"
                style={{
                  backgroundColor: "#389081",
                  borderColor: "#389081",
                  height: "32px",
                  padding: "0 14px",
                  fontSize: "13px",
                  borderRadius: "6px"
                }}
              >
                <FontAwesomeIcon icon={faFileExcel} className="me-1" />
                {isLoadingExcel ? "Exporting..." : "Excel"}
              </button>

              <button
                type="button"
                onClick={exportPdf}
                disabled={isLoadingPdf}
                className="btn btn-sm text-white"
                style={{
                  backgroundColor: "#389081",
                  borderColor: "#389081",
                  height: "32px",
                  padding: "0 14px",
                  fontSize: "13px",
                  borderRadius: "6px"
                }}
              >
                <FontAwesomeIcon icon={faFilePdf} className="me-1" />
                {isLoadingPdf ? "Exporting..." : "PDF"}
              </button>
            </div>
          </div>

          {/* Date filters – tight */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "10px",
              marginBottom: "14px"
            }}
          >
            <input
              type="date"
              name="start_date"
              value={start_date}
              onChange={handleChangeDate}
              className="form-control form-control-sm"
              style={{
                width: "145px",
                height: "32px",
                padding: "2px 8px",
                fontSize: "13px",
                borderRadius: "6px"
              }}
            />
            <input
              type="date"
              name="end_date"
              value={end_date}
              onChange={handleChangeDate}
              className="form-control form-control-sm"
              style={{
                width: "145px",
                height: "32px",
                padding: "2px 8px",
                fontSize: "13px",
                borderRadius: "6px"
              }}
            />
          </div>
        </div>

        {/* Monthly totals bar */}
        {isSuccess && reportList.length > 0 && (
          <div
            style={{
              marginBottom: "14px",
              background: "linear-gradient(135deg, #389081, #027a5f)",
              borderRadius: "10px",
              padding: "14px 16px",
              color: "#fff"
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: "10px", fontSize: "15px" }}>
              TOTAL CONSUMPTION ({start_date.split("-")[0]})
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(12, 1fr)",
                gap: "6px",
                textAlign: "center"
              }}
            >
              {["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"].map(
                (month) => (
                  <div key={month}>
                    <div
                      style={{
                        fontSize: "11px",
                        opacity: 0.85,
                        textTransform: "uppercase",
                        marginBottom: "2px"
                      }}
                    >
                      {headData.find((h) => h.id === month)?.label}
                    </div>
                    <div style={{ fontWeight: 700, fontSize: "15px" }}>
                      {formatNumber(monthlyTotals[month])}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        )}

        {/* TABLE */}
        <MuiPaper style={{ borderRadius: "10px", overflow: "hidden" }}>
          <EnhancedSearchTableToolbar
            term={searchValue}
            handler={handleSearch}
            placeholder="Search product or generic name..."
          />

          <StickyHeadTable
            data={reportList}
            columns={headData}
            pagination={
              <CustomTablePagination
                colSpan={headData.length}
                activePage={activePage}
                page={page}
                rowsPerPage={rowsPerPage}
                count={total}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                isTotalCount
              />
            }
          >
            {isLoading && (
              <TableRow>
                <TableCell colSpan={headData.length} align="center">
                  <LoadingGif />
                </TableCell>
              </TableRow>
            )}

            {isSuccess && reportList.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={headData.length}
                  align="center"
                  style={{ fontSize: "1rem", color: "#7f8c8d" }}
                >
                  No consumption data found for the selected period
                </TableCell>
              </TableRow>
            )}

            {isSuccess &&
              reportList.map((row, idx) => (
                <TableRow key={idx} hover>
                  <CustomTableCell>
                    {idx + 1 + page * rowsPerPage}
                  </CustomTableCell>
                  <CustomTableCell>
                    <strong>{row.product_name}</strong>
                  </CustomTableCell>
                  <CustomTableCell>{row.generic_name || "-"}</CustomTableCell>
                  <CustomTableCell>{row.country_of_origin || "-"}</CustomTableCell>
                  {["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"].map(
                    (month) => (
                      <CustomTableCell key={month} align="center">
                        <span
                          style={{
                            fontWeight: 600,
                            color: row[month] > 0 ? "#027a5f" : "#bdc3c7"
                          }}
                        >
                          {formatNumber(row[month])}
                        </span>
                      </CustomTableCell>
                    )
                  )}
                </TableRow>
              ))}

            {isError && (
              <TableRow>
                <TableCell
                  colSpan={headData.length}
                  align="center"
                  className="text-danger"
                >
                  Failed to load data. Please try again.
                </TableCell>
              </TableRow>
            )}
          </StickyHeadTable>
        </MuiPaper>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  snackbars: state.snackbar
});

const mapDispatchToProps = (dispatch) => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) }
});

export default connect(mapStateToProps, mapDispatchToProps)(ConsumptionReport);